import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import Backend from "../../../utils/Backend";
import Notify from "../../../utils/Notify";

export default class EditStaffModal extends Component {
  constructor(props) {
    super(props);

    const staff = props.staff || {};
    const user = staff?.company_member?.user || {};
    const companyMember = staff?.company_member || {};

    this.state = {
      firstName: user.first_name || "",
      lastName: user.last_name || "",
      email: user.email || "",
      phoneNumber: user.phone_number || "",
      role: companyMember.role || "staff",
      isActive: user.is_active !== undefined ? user.is_active : true,
      loading: false,
    };
  }

  async _handleSave() {
    try {
      const { firstName, lastName, email, phoneNumber, role, isActive } =
        this.state;

      // Validation
      if (!firstName.trim()) {
        Notify.error("First name is required");
        return;
      }

      if (!lastName.trim()) {
        Notify.error("Last name is required");
        return;
      }

      if (!email.trim()) {
        Notify.error("Email is required");
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        Notify.error("Please enter a valid email address");
        return;
      }

      this.setState({ loading: true });

      const companyMemberId = this.props.staff?.company_member?.id;

      if (!companyMemberId) {
        Notify.error("Invalid staff member data");
        this.setState({ loading: false });
        return;
      }

      // Call backend API to update company member
      await Backend.updateCompanyMember(companyMemberId, {
        user: {
          first_name: firstName.trim(),
          last_name: lastName.trim(),
          email: email.trim(),
          phone_number: phoneNumber.trim(),
          is_active: isActive,
        },
        role: role,
      });

      Notify.success("Staff member updated successfully");
      this.setState({ loading: false });

      if (this.props.onUpdated) {
        this.props.onUpdated();
      }
    } catch (error) {
      console.error("Update failed:", error);
      
      // Check if it's a 404 or endpoint not found error
      if (error.message && error.message.includes("404")) {
        Notify.error("Backend endpoint not implemented yet. Please contact your backend team to implement PATCH /api/company-members/{id}/");
      } else {
        Notify.error(error.message || "Failed to update staff member");
      }
      
      this.setState({ loading: false });
    }
  }

  render() {
    const { show, onHide } = this.props;
    const { firstName, lastName, email, phoneNumber, role, isActive, loading } =
      this.state;

    return (
      <Modal show={show} onHide={onHide} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Staff Member</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="form-group row">
            <div className="col-lg-6">
              <label>
                First Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter first name"
                value={firstName}
                onChange={(e) => this.setState({ firstName: e.target.value })}
                disabled={loading}
              />
            </div>

            <div className="col-lg-6">
              <label>
                Last Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter last name"
                value={lastName}
                onChange={(e) => this.setState({ lastName: e.target.value })}
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-group row">
            <div className="col-lg-6">
              <label>
                Email <span className="text-danger">*</span>
              </label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter email"
                value={email}
                onChange={(e) => this.setState({ email: e.target.value })}
                disabled={loading}
              />
            </div>

            <div className="col-lg-6">
              <label>Phone Number</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter phone number"
                value={phoneNumber}
                onChange={(e) =>
                  this.setState({ phoneNumber: e.target.value })
                }
                disabled={loading}
              />
            </div>
          </div>

          <div className="form-group row">
            <div className="col-lg-6">
              <label>Role</label>
              <select
                className="form-control"
                value={role}
                onChange={(e) => this.setState({ role: e.target.value })}
                disabled={loading}
              >
                <option value="staff">Staff</option>
                <option value="manager">Manager</option>
                <option value="admin">Admin</option>
                <option value="cashier">Cashier</option>
                <option value="chef">Chef</option>
              </select>
            </div>

            <div className="col-lg-6">
              <label>Status</label>
              <div className="mt-3">
                <span className="switch switch-sm">
                  <label>
                    <input
                      type="checkbox"
                      checked={isActive}
                      onChange={(e) =>
                        this.setState({ isActive: e.target.checked })
                      }
                      disabled={loading}
                    />
                    <span></span>
                  </label>
                </span>
                <span className="ml-3">
                  {isActive ? "Active" : "Inactive"}
                </span>
              </div>
            </div>
          </div>

          {/* Removed the backend warning alert since the endpoint is configured */}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light" onClick={onHide} disabled={loading}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => this._handleSave()}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Changes"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
